import { gql } from 'apollo-angular';

export const UPDATE_WORK_ORDER = gql`
  mutation updateWorkOrder(
    $updateWorkOrderInput: UpdateWorkOrderInput!
    $workOrderItems: [UpdateWorkOrderSowInput!]
    $fileAttachments: [UpdateWorkOrderAttachmentInput!]
  ) {
    updateWorkOrder(
      updateWorkOrderInput: $updateWorkOrderInput
      workOrderItems: $workOrderItems
      fileAttachments: $fileAttachments
    ) {
      id
      workOrderStatus
      workOrderNo
      partnerId
    }
  }
`;

export const REMOVE_WORK_ORDER = gql`
  mutation removeWorkOrder($id: Int!) {
    removeWorkOrder(id: $id)
  }
`;

export const CREATE_ACTIVITY = gql`
  mutation createTaskTimeline($createTaskTimelineInput: CreateTaskTimelineInput!) {
    createTaskTimeline(createTaskTimelineInput: $createTaskTimelineInput){
      id
    }
  }
`;

export const MODIFY_TASK_ASSIGNMENT = gql`
  mutation modifyTaskAssignment($id: Int!, $updateServiceTaskAssignmentInput: UpdateServiceTaskAssignmentInput!, $CreateTaskTimelineInput: CreateTaskTimelineInput!) {
    modifyTaskAssignment(id: $id, updateServiceTaskAssignmentInput: $updateServiceTaskAssignmentInput, CreateTaskTimelineInput: $CreateTaskTimelineInput)
  }
`;

export const MARK_AS_COMPLETED_ORDER_SERVICE = gql`
  mutation markAsCompletedAllServiceTaskAssignmentsForAnOrderService($orderServiceId: Int!) {
    markAsCompletedAllServiceTaskAssignmentsForAnOrderService(orderServiceId: $orderServiceId)
  }
`;

export const MARK_AS_COMPLETED_ORDER = gql`
  mutation markAsCompletedAllServiceTaskAssignmentsForAnOrder($orderId: Int!) {
    markAsCompletedAllServiceTaskAssignmentsForAnOrder(orderId: $orderId)
  }
`;

export const REMOVE_TASK_TIMELINE = gql`
  mutation removeTaskTimeline($id: Int!) {
    removeTaskTimeline(id: $id)
  }
`;

export const UPDATE_ORDER = gql`
  mutation updateOrder($id: Int!, $updateOrderInput: UpdateOrderInput!) {
    updateOrder(id: $id, updateOrderInput: $updateOrderInput){
      id
    }
  }
`;
